import ProduccionLayout from '@/components/ProduccionLayout';
import SaludSeguridadTab from './SaludSeguridadTab';

export default function SaludSeguridadProduccion({ user, onLogout }) {
  return (
    <ProduccionLayout user={user} onLogout={onLogout}>
      <SaludSeguridadTab user={user} onLogout={onLogout} />
    </ProduccionLayout>
  );
}
